import { createContext, useContext } from 'react';
import { AskRequest } from '@hone-automation/common';
import { UIReportTransaction } from 'types/askcustomer';

export type ConversationMode = 'queue' | 'dataRowModal';
export type ConversationSidePanel = 'Summary' | 'Details' | null;

interface ConversationPanelContextValue {
  mode: ConversationMode;
  locationId?: string;
  messageLoading?: boolean;
  reportId?: string;
  openSidePanel?: (panel: ConversationSidePanel) => void;
  // Callback when the request is updated (used in both modes)
  onRequestUpdate?: (request: AskRequest) => void;
  // Callback specific for DataRowModal mode
  onTransactionUpdate?: (transaction: UIReportTransaction) => void;
  // Function to refetch flaggedTransactions
  refetchFlaggedTransactions?: () => void;
}

const ConversationPanelContext = createContext<ConversationPanelContextValue>({
  mode: 'queue',
});

export const useConversationPanelContext = () => useContext(ConversationPanelContext);
export const ConversationPanelContextProvider = ConversationPanelContext.Provider;
